import NumberInput from '@wandb/weave/common/components/elements/NumberInput';
import React, {useCallback, useState} from 'react';

import {useDebouncedValue} from '../../../../../util/useDebouncedValue';
import {SettingTitle} from '../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

const DEFAULT_STRIDE_LENGTH = 1;

export const StrideLength = () => {
  const {config, updateConfig, unsetConfigField} =
    useMediaSettingsDrawerContext();
  // underlying NumberInput handles debouncing
  const updateStrideLength = useCallback(
    (newValue?: number) => {
      const parsedValue = newValue ?? DEFAULT_STRIDE_LENGTH;
      if (parsedValue === DEFAULT_STRIDE_LENGTH) {
        // avoid storing default values in the config
        unsetConfigField('stepStrideLength');
      } else {
        updateConfig({
          stepStrideLength: parsedValue,
        });
      }
    },
    [updateConfig, unsetConfigField]
  );

  const {value: debouncedValue, debouncedSetValue} = useDebouncedValue(
    config.stepStrideLength,
    500,
    updateStrideLength
  );

  // Local state to control the value of the input so we don't have to wait for the updateConfig call to propagate
  const [value, setValue] = useState(debouncedValue);

  return (
    <div
      className="flex items-center justify-between"
      data-test="step-stride-length-input">
      <SettingTitle
        title="Stride length"
        configField="stepStrideLength"
        unsetConfigField={() => unsetConfigField('stepStrideLength')}
      />
      <NumberInput
        placeholder="1"
        min={1}
        value={value}
        onChange={newValue => {
          setValue(newValue);
          debouncedSetValue(newValue);
        }}
        stepper
        useStepperPlusMinus
      />
    </div>
  );
};
